import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalWaitTimesInput,
  terminalWaitTimesInputSchema,
} from "./shared/terminalWaitTimes.input";
import {
  type TerminalWaitTime,
  terminalWaitTimeSchema,
} from "./shared/terminalWaitTimes.output";

/**
 * Metadata for the fetchTerminalWaitTimes endpoint
 */
export const terminalWaitTimesMeta = {
  functionName: "fetchTerminalWaitTimes",
  endpoint: "/terminalWaitTimes",
  inputSchema: terminalWaitTimesInputSchema,
  outputSchema: terminalWaitTimeSchema.array(),
  sampleParams: {},
  endpointDescription: "List wait time information for all terminals.",
} satisfies EndpointMeta<TerminalWaitTimesInput, TerminalWaitTime[]>;

/**
 * Fetch function for retrieving wait time information for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalWaitTimesInput,
  TerminalWaitTime[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalWaitTimesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalWaitTimes.endpoints").terminalWaitTimesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving wait time information for all terminals
 */
export const fetchTerminalWaitTimes: FetchFactory<
  TerminalWaitTimesInput,
  TerminalWaitTime[]
> = fetch;

/**
 * React Query hook for retrieving wait time information for all terminals
 */
export const useTerminalWaitTimes: HookFactory<
  TerminalWaitTimesInput,
  TerminalWaitTime[]
> = useHook;
